export default "__VITE_ASSET__2640ea04__"